var _path, _g, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-ms",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#006",
    d: "M0 0h512v512H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.518 230.94h201.077l-.24 143.974c1.673 57.876-34.176 93.789-100.138 109.982-46.847-11.707-100.86-35.92-100.939-108.34l.24-145.618z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.069 22.713h169.3l-.201 120.79c1.408 48.558-28.777 78.69-84.317 92.276-39.437-9.82-84.916-30.13-84.982-90.9l.201-122.17z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#00a2bd",
    transform: "matrix(1.135 0 0 1.1421 235.95 209.34)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.638 389.586c-6.99 52.938-47.506 76.068-94.442 88.344-41.546-11.214-86.242-29.118-94.905-88.078l189.352-.266z",
    fill: "#a53d08"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M155.77 197.17c.094.094.658 9.295-4.319 14.929 4.413 1.409 7.418-.282 8.826-2.066 1.409-1.784 1.879-4.037 1.879-4.037s1.22-.751 1.408-2.441c.094-2.348-.939-2.348-1.784-2.817l.187-5.258s-5.07-3.099-6.197 1.69z",
    strokeWidth: 1.25,
    fill: "#ffc6b5",
    transform: "matrix(1.135 0 0 1.1421 235.95 209.34)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.49 210.32l-1.503-1.221",
    strokeLinecap: "round",
    strokeWidth: "1pt",
    fill: "#ff9a08",
    transform: "matrix(1.135 0 0 1.1421 235.95 209.34)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.64 69.393s.117 5.625-.235 6.211c-.351.586-3.554 2.07-3.554 2.07l2.734 5.82s7.695-1.093 7.734-1.093 3.321-8.711 3.321-8.711-1.719-2.89-1.289-5.898c-2.578-8.165-8.594 1.64-8.711 1.601z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#ffc6b5",
    transform: "matrix(1.135 0 0 1.1421 235.95 209.34)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M131.45 203.09s4.319 4.319 9.295 3.756c11.268-1.22 14.554-11.267 18.028-11.361s5.634 6.103 8.92 5.352c-2.817-5.164-5.821-16.619-5.352-24.694.47-8.075.47-42.065.47-42.065s-5.634-17.558-8.263-20.469c2.629-2.817 4.413-7.793 4.319-13.239-.094-5.446 0-11.455 0-11.455s1.314-1.502 1.221-5.727c-.094-4.226-7.136-10.328-8.075-10.047-.939.281-9.765 7.887-10.516 9.67-.752 1.785-1.784-6.478-.094-7.23 1.69-.75-3.944-1.22-7.512 3.005-3.568 4.226-2.535 124.69-2.441 124.5z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.25,
    fill: "#005121",
    transform: "matrix(1.135 0 0 1.1421 235.95 209.34)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M337.08 260.845l37.506.135-.268-17.387 13.663.134.134 17.253h37.37l.135 13.48-37.505.134-.3 158.957-13.327.085-.17-159.175-37.245.135.008-13.748z",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.03 81.959s-2.258-.398-3.984.133 2.656-19.586 2.656-21.246c1.527-.73 9.162-2.125 8.963-7.503-.531-3.253-11.818.2-11.619 4.316-.73 2.058-8.099 23.038-6.639 29.943 2.589 2.058 7.37 1.66 10.623 1.129v-6.772z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#ffc6b5",
    transform: "matrix(1.135 0 0 1.1421 235.95 209.34)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.22 53.211s-.664 3.718 2.722 4.25",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.625,
    fill: "none",
    transform: "matrix(1.135 0 0 1.1421 235.95 209.34)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M129.2 53.144c-.133.066-4.382 2.722-4.382 2.722m4.122-1.062l-2.988 2.191m1.858-4.647l-3.32 1.992",
    stroke: "#000",
    strokeWidth: 0.375,
    fill: "none",
    transform: "matrix(1.135 0 0 1.1421 235.95 209.34)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.49 163.56l30.14 31.267c10.422-11.455 3.193-54.272-10.515-62.158-1.643 5.07-4.437 11.149-7.407 13.109-6.534 4.453-22.546 9.659-17.194 12.993 1.22-1.69 4.413-3.286 5.915.47 1.784 5.915-6.666 6.291-6.666 6.291s-5.352-.658-6.291-6.104c-.939-5.445 7.972-10.417 8.732-10.797.751-.282 12.394-3.38 14.366-13.709 2.441-10.141 4.976-8.638 5.446-8.826 15.21 1.502 25.163 28.732 25.727 47.886.563 19.154-7.793 31.83-9.296 32.675-1.502.845-36.243-41.219-36.243-41.219l3.286-1.878z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#ff9a08",
    transform: "matrix(1.135 0 0 1.1421 235.95 209.34)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M117.46 134.45l.187 56.43m-3.567-55.4l.187 51.267M110.42 142.9l.187 40.75m-3.187-37.84l.188 33.709m-3.388-32.199v28.45m-3.47-26.2v22.534m-3.006-20.754v17.276",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none",
    transform: "matrix(1.135 0 0 1.1421 235.95 209.34)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M95.021 167.13l31.079 35.58m1.5-58.02s14.085 30.798 1.033 56.149M91.359 160.65s1.033-2.723 2.347-1.596m-4.788-6.294s-5.634 4.976-2.535 8.169",
    stroke: "#ffdf00",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    fill: "none",
    transform: "matrix(1.135 0 0 1.1421 235.95 209.34)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M141.03 82.999s.47 4.32-.469 7.605 3.568 12.394 1.877 14.272m.472 8.824l11.831-.094",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none",
    transform: "matrix(1.135 0 0 1.1421 235.95 209.34)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M138.59 118.49c.094.187 1.408 6.197 1.032 10.328m2.818-8.168c-.375 1.221-5.258 15.117-5.07 15.68m7.98-21.97c.094.282-.375 8.826-1.69 10.047m7.7-10.707s7.7 17.84 7.606 24.882 2.629 21.314.845 27.605M153.8 138.4s-.564 13.239-6.103 18.403c-5.54 5.165 13.239 19.906 13.239 19.906",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: "1pt",
    fill: "none",
    transform: "matrix(1.135 0 0 1.1421 235.95 209.34)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M153.61 175.86s2.066 18.215 5.54 19.53m-22.53-50.05c.094.188-1.878 12.3-.282 14.272 1.597 1.972 14.836 20.469 14.272 39.624m-3.76-5.726s-.376 11.549-11.08 12.488m7.89-20.088s3.193 12.018-7.699 19.624",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    fill: "none",
    transform: "matrix(1.135 0 0 1.1421 235.95 209.34)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M147.88 156.89s12.3 12.77 12.864 18.404m-9.294-61.314s2.16 9.107 1.315 10.704",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: "1pt",
    fill: "none",
    transform: "matrix(1.135 0 0 1.1421 235.95 209.34)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M113.51 132.69s-1.317-2.305-1.152-4.857-.412-6.502 7.82-9.713c5.021-5.103 10.618-8.149 13.663-9.712 4.445-2.881 7.327-2.223 9.96-3.211 1.729-1.975 1.646-6.338 3.457-10.206 1.811-3.869 5.021-11.853 8.478-10.618 3.458 1.235.741 11.606-.576 15.228s-2.469 7.408-4.774 9.63c-2.305 2.223-12.758 6.256-14.816 6.997s-11.441 2.88-13.828 6.174c-2.388 3.292-2.223 8.149-8.232 10.289z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#ffc6b5",
    transform: "matrix(1.135 0 0 1.1421 235.95 209.34)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M112.85 125.78c.247-.082 4.115-1.317 5.926 2.141",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none",
    transform: "matrix(1.135 0 0 1.1421 235.95 209.34)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M141.91 55.2s-1.74 2.837-2.222 4.561c-.374 1.29-1.58-.087-2.218 2.708l1.035.181c-.412.823-.546 2.214-.628 2.543-.083.33-.662 1.834-.576 2.964.046.583 1.152 3.128 10.124-.741 8.972-3.869-2.881-14.85-5.515-12.216z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.25,
    fill: "#ffc6b5",
    transform: "matrix(1.135 0 0 1.1421 235.95 209.34)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M140.9 55.563c.921-.494 7.457-1.07 6.368 11.688 1.257-.165 2.011-.33 2.764.905.754 1.235.671 2.717 2.011 2.717 1.341 0 1.509-.247 1.844-1.235.334-.988 5.53 1.152 6.869-3.457-.232-.897-3.183-2.305-3.519-3.951.755-2.305-.335-9.795-9.885-10.207-4.944-.082-5.948 1.975-6.452 3.54z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.261,
    fill: "#c59200",
    transform: "matrix(1.135 0 0 1.1421 235.95 209.34)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M140.42 58.115c.083.082 2.964.905 3.293 2.305",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: "1pt",
    fill: "none",
    transform: "matrix(1.135 0 0 1.1421 235.95 209.34)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M397.336 279.583c0 .492-.377.892-.843.892s-.842-.4-.842-.892.377-.893.842-.893.843.4.843.893z",
    fillRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M154.38 61.542s-1.055 5.078 3.594 7.07m-7.034-6.445s1.722.078 1.722 1.68c0 1.601-1.414 1.796-1.296 3.086.117 1.289 2.425 1.718 2.503 2.812M143.4 52.792c.078 0 8.243.938 7.774 2.969-.469 2.031-1.758 1.21-1.719 2.968s3.281.704 3.281.704.196-1.485 1.563-1.368.742 1.68 2.617 1.64",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    fill: "none",
    transform: "matrix(1.135 0 0 1.1421 235.95 209.34)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M138.41 65.458l1.936-.064",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    fill: "none",
    transform: "matrix(1.135 0 0 1.1421 235.95 209.34)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M143.45 73.696s.72 3.36-2 3.04",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: "1pt",
    fill: "none",
    transform: "matrix(1.135 0 0 1.1421 235.95 209.34)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .063v21.182L255.95 189.52h32.218v-21.182L32.218.064H0zm288.168 0v21.181L32.218 189.52H0v-21.181L255.95.063h32.218z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.07.063v189.456h48.028V.063H120.07zM0 63.215v63.152h288.168V63.215H0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 75.845v37.892h288.168V75.845H0zM129.676.063v189.456h28.816V.063h-28.816zM0 189.519l96.056-63.152h21.478l-96.056 63.152H0zM0 .063l96.056 63.152H74.578L0 14.185V.062zm170.634 63.152L266.69.063h21.478l-96.056 63.152h-21.478zm117.534 126.304l-96.056-63.152h21.478l74.578 49.031v14.121z",
    fill: "#c00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMs);
export default __webpack_public_path__ + "static/media/ms.88a8b4177f0db47849fe2eb30caa0e4e.svg";
export { ForwardRef as ReactComponent };